import { TextBox } from "@progress/kendo-react-inputs";
import React from "react";

interface InputProps {
  name: string | null;
  value: string | null;
  onChange: (value: string | number | readonly string[] | undefined) => void;
}

const InputPassword: React.FC<InputProps> = ({name ,value, onChange }) => {
  return (
    <div className="inputConnexion">
      <p>{name}</p>
      <TextBox
        autoComplete="current-password"
        value={value !== null ? value :""}
        onChange={(e) => onChange(e.target.value)}
        type="password"
        required={true}
      />
    </div>
  );
};

export default InputPassword;
